import { ChevronDown, ChevronRight } from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react';

import { EmptyView } from 'base/ui/status';

import { getLabel } from '../../../helpers/StoreHelper';
import { sanitizeToId, sanitizeToTitle } from 'base/utils/common';

function SelectDeliveryPoint({
    delivery_route, selected_delivery_point,
    onDeliveryPointSelected
}){
    const [search_term, setSearchTerm] = useState('');
    const [area_dpoints_map, setAreaDpointsMap] = useState(null);
    const [expanded_areas, setExpandedAreas] = useState(new Set([selected_delivery_point?.area]));


    useEffect(() => {
        // filter out deliverypoints
        const filtered_delivery_points = delivery_route.delivery_points?.filter(dpoint => {
            if (!search_term.trim() || search_term.trim().length < 2) return true;            
            const name_match = dpoint.name.toLowerCase().includes(search_term.toLowerCase());        
            return name_match;
        }) || [];

        const area_dpoints_map = new Map();
        for (const dpoint of filtered_delivery_points) {
            if (!area_dpoints_map.has(dpoint.area)) {
                area_dpoints_map.set(dpoint.area, []);
            }
            area_dpoints_map.get(dpoint.area).push(dpoint);
        }
        setAreaDpointsMap(area_dpoints_map);
    }, [search_term]);


    if(!delivery_route.delivery_points.length){
        return (
            <EmptyView title="No Delivery Points Configured" height="250px" />
        )
    }


    return (
        <div className='w3-row w3-relative'  style={{padding: "8px 8px 32px 8px"}}>
            <div className='w3-margin-bottom-32'>
            {
                delivery_route.delivery_points && delivery_route.delivery_points?.length >= 10 
                ? <input 
                    className='input-primary tw-mb-2' 
                    placeholder={`Search ${getLabel(delivery_route.other_config, "delivery_location", "Delivery Location")}`}
                    value={search_term}
                    onChange={(e) => setSearchTerm(e.target.value)} 
                />
                : null
            }
            {
                area_dpoints_map?.size ? (
                    Array.from(area_dpoints_map).map(
                        ([area, dpoints]) => {
                            return (
                                <React.Fragment key={area}>
                                    { /* area header */
                                        area
                                        ?   <div
                                                className='w3-flex w3-flex-vcenter w3-bold w3-border-top w3-large'
                                                onClick={() => {
                                                    expanded_areas.has(area)
                                                    ? expanded_areas.delete(area)
                                                    : expanded_areas.add(area);
                                                    setExpandedAreas(new Set(expanded_areas))
                                                }}
                                            >
                                                <p className='tw-flex tw-items-center tw-gap-2 tw-text-sm tw-capitalize'>
                                                    {area} {
                                                        dpoints.length > 1 
                                                        ?   <span className='tw-text-primary'>{`(${dpoints.length})`}</span>
                                                        :   null
                                                    }
                                                </p>
                                                {
                                                    expanded_areas?.has(area)
                                                        ? <ChevronDown  size={26} className='tw-m-4 tw-ml-auto' />
                                                        : <ChevronRight size={26} className='tw-m-4 tw-ml-auto' />
                                                }
                                            </div>
                                        :   null
                                    }
                                    {
                                        dpoints.map(
                                            (dpoint) => {
                                                return <label 
                                                        className={
                                                            `w3-flex w3-padding-8 tw-gap-4 ${dpoint.area ? "w3-padding-left" : ""}
                                                                ${( dpoint.area && !expanded_areas.has(dpoint.area) ? "w3-hide" : "")}`
                                                        }
                                                        htmlFor={dpoint.name}
                                                    >
                                                        <div className='w3-list tw-grow tw-text-sm'>
                                                            <div className='tw-flex tw-items-center tw-gap-4'>
                                                                <div className='w3-bold tw-capitalize'>
                                                                    {sanitizeToTitle(dpoint.name.replace(area, "")) || dpoint.name}
                                                                </div>
                                                                {
                                                                    dpoint.description
                                                                    ?   <span className='tw-bg-primary tw-text-white tw-rounded-md tw-px-2 tw-py-1'>
                                                                            {dpoint.description}
                                                                        </span>
                                                                    :   null
                                                                }
                                                            </div>
                                                            {
                                                                dpoint.address
                                                                ?   <div className='w3-text-grey w3-small'>
                                                                        {dpoint.address}
                                                                    </div>
                                                                :   null
                                                            }
                                                        </div>
                                                        <div className='w3-margin-left-auto w3-flex w3-flex-vcenter'>
                                                            <input 
                                                                className='w3-radio w3-input'
                                                                type="radio"
                                                                name={`${delivery_route._id}_dpoint`}
                                                                id={dpoint.name}
                                                                defaultChecked={selected_delivery_point?.name === dpoint.name}
                                                                onChange={
                                                                    (evt) => evt.target.checked && onDeliveryPointSelected(dpoint)
                                                                }
                                                            />
                                                        </div>
                                                    </label>
                                            }
                                        )
                                    }
                                </React.Fragment>
                            );
                        }
                    )
                ) : (
                <div className="w3-padding-16 w3-center w3-text-grey">
                    No delivery location match your search.
                </div>
                )
            }
            </div>
        </div>
    )
}

export default SelectDeliveryPoint;